import { renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["Primitive"], _mergeProps({
        "data-slot": "sidebar-menu-button",
        "data-sidebar": "menu-button",
        "data-size": $props.size,
        "data-active": $props.isActive,
        class: $setup.cn($setup.sidebarMenuButtonVariants({ variant: $props.variant, size: $props.size }), $setup.props.class),
        as: $props.as,
        "as-child": $props.asChild
    }, _ctx.$attrs), {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */, ["data-size", "data-active", "class", "as", "as-child"]));
}
